import React, { useState, useEffect } from "react";
const Field = (props) => {
    if (props.visibility !== "visible" || props.isHidden) {
        return React.createElement(React.Fragment, null);
    }
    const [value, setValue] = useState(props.defaultValue || "");
    const [error, setError] = useState("");
    const validate = (value) => {
        if (!props.isRequired) {
            return true;
        }
        return props.validationFunction(value);
    };
    useEffect(() => {
        if (props.validationTrigger === 0) {
            props.onValidate(props.id, validate(props.defaultValue));
            return;
        }
        const validation = validate(value);
        if (!validation) {
            setError(props.errorMessage || props.defaultError);
        }
        else {
            setError("");
        }
    }, [props.validationTrigger]);
    const className = (() => {
        let cN = [];
        if (typeof props.defaultClassName !== "undefined") {
            cN.push(props.defaultClassName);
        }
        if (typeof props.layoutGridColumnSpan !== "undefined") {
            cN.push("col-span-" + props.layoutGridColumnSpan);
        }
        if (props.size?.length) {
            cN.push("size-" + props.size);
        }
        if (props.labelPlacement?.length) {
            cN.push("label-" + props.labelPlacement);
        }
        if (props.descriptionPlacement?.length) {
            cN.push("description-" + props.descriptionPlacement);
        }
        if (props.description?.length) {
            cN.push("has-description");
        }
        if (props.cssClass?.length) {
            cN.push(props.cssClass);
        }
        return cN.join(" ");
    })();
    const Tag = props.isGroup ? "fieldset" : "label";
    const InputTag = typeof props.tag !== "undefined" ? props.tag : "input";
    const onChange = (changedValue, multiple = false) => {
        if (!multiple) {
            setValue(changedValue);
            if (props.onChange) {
                props.onChange(changedValue);
            }
            props.onValidate(props.id, validate(changedValue));
            return;
        }
        const checked = value.includes(changedValue);
        let newValue = [...value];
        if (!checked) {
            newValue.push(changedValue);
        }
        else {
            newValue = newValue.filter((e) => e !== changedValue);
        }
        setValue(newValue);
        if (props.onChange) {
            props.onChange(newValue);
        }
        props.onValidate(props.id, validate(newValue));
    };
    return (React.createElement(Tag, { className: className },
        React.createElement("span", { className: "label" },
            props.label,
            props.isRequired ? (React.createElement("span", { className: "indicator" }, props.requiredIndicator)) : (React.createElement(React.Fragment, null))),
        props.description?.length ? (React.createElement("span", { className: "description" }, props.description)) : (React.createElement(React.Fragment, null)),
        error.length ? React.createElement("span", { className: "error" }, error) : React.createElement(React.Fragment, null),
        props.isGroup ? (React.createElement("div", null, props.choices.map((choice, i) => {
            return (React.createElement("label", { key: i },
                React.createElement("input", { "aria-required": props.isRequired, required: props.isRequired, name: props.type === "radio"
                        ? "input_" + props.id
                        : "input_" + props.id + "." + (i + 1), id: "choice_" + props.formId + "_" + props.id + "_" + (i + 1), type: props.type, onChange: () => {
                        onChange(choice.value, props.multiple);
                    }, checked: props.type === "radio"
                        ? (value || props.defaultValue) == choice.value
                        : (value || props.defaultValue).includes(choice.value), value: choice.value }),
                React.createElement("span", { className: "label" },
                    choice.text,
                    props.isRequired && props.choices.length === 1 ? (React.createElement("span", { className: "indicator" }, props.requiredIndicator)) : (React.createElement(React.Fragment, null)))));
        }))) : (React.createElement(InputTag, { autoComplete: props.autocompleteAttribute?.length
                ? props.autocompleteAttribute
                : undefined, "aria-required": props.isRequired, required: props.isRequired, name: props.type === "multiselect"
                ? "input_" + props.id + "[]"
                : "input_" + props.id, id: "input_" + props.formId + "_" + props.id, type: InputTag === "input" ? props.type : undefined, placeholder: props.placeholder, onChange: (e) => {
                const value = props.type === "file" ? e.target : e.target.value;
                onChange(props.multiple
                    ? [...e.target.options]
                        .filter((e) => e.selected)
                        .map((e) => e.value)
                    : value);
                if (props.onChange) {
                    props.onChange(e);
                }
            }, min: props.min, max: props.max, multiple: props.multiple || props.multipleFiles, accept: props.accept, value: props.type === "file" ? value.value || "" : value }, props.children)),
        props.neighbour));
};
export default Field;
